{{ domain }}
<i
  class="icon icon-pin"
  (click)="selectDomain()"
  (keydown.enter)="selectDomain()"></i>
